const apiUrl =
    Globals.api_theme_url;
const headers = {
    "Content-Type": "application/json",
    "Accept": "application/json"
};

export default (el) => {
    if(el) {
        el =
            el.find('.dpl-ad');
    } else {
        el =
            $('.dpl-ad');
    }

    if(el.length>0) {
        el.each((i,e) => {

            /**
             * Load
             */
            if(!$(e).hasClass('dpl-please-wait')) {
                const group =
                    $(e).data('group');
                const cat =
                    $(e).data('cat');
                const count =
                    $(e).data('count');
                const type =
                    $(e).data('type');
                const id =
                    $(e).data('id');

                fetch(apiUrl + 'ad', {
                    method: "POST",
                    headers,
                    body: JSON.stringify({
                        'category__in': cat,
                        'group__in': group,
                        'html': true,
                        id,
                        count,
                        type
                    })
                })
                    .then(response => response.json())
                    .then(html => {
                        if (html) {
                            $(e).html(html);
                            $(e).removeAttr('style');
                        } else {
                            const parent = $(e).parents('.acf-block-preview');
                            if(parent.length>0) {
                                $(e).html('' +
                                    '<p class="bg__grey addpadding__top addpadding__bottom addpadding__left addpadding__right">' +
                                    'Ad can no longer be displayed. It may have expired or been removed.' +
                                    '</p>');
                            } else {
                                $(e).remove();
                            }
                        }
                    });
            } else {
                /**
                 * Log
                 */
                const redirectId =
                    $(e).data('redirectid');
                if(redirectId) {
                    fetch(apiUrl + 'ad/click/' + redirectId, {
                        method: "GET",
                        headers,
                    })
                        .then(response => response.json())
                        .then(json => {
                            if(json) {
                                setTimeout(() => {
                                    location.replace(json.link.url);
                                },1000);
                            }
                        });
                } else {
                    window.location =
                        window.location.pathname;
                }
            }

        });
    }

}